<template>
    <div class="item">
        <div class="txt">
            <p class="name">{{ data.title }}</p>
            <p class="time">{{ data.date }}</p>
            <p v-if="data.users">{{ userNum }}:{{ data.users }}</p>
        </div>
        <div class="cir">
            <el-progress :width="88" type="circle" :percentage="data.rate" :color="data.color"></el-progress>
        </div>
    </div>
</template>

<script>
export default {
    name: "Item",
    props: ["data"],
    computed: {
        userNum() {
            return this.$t("zhiji.serviceData.userNum");
        }
    }
};
</script>

<style lang="scss" scoped>
.item {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 40px;
    .cir {
        width: 88px;
        height: 88px;
    }
    &:after {
        display: inline-block;
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        height: 89px;
        width: 1px;
        background: #d9e4ef;
    }

    .txt {
        .name {
            font-weight: bold;
        }

        .time {
            color: #9b9ba3;
            margin: 2px 0;
        }
    }
}
</style>
